// extracted by mini-css-extract-plugin
export const colorPickerPopover = "smartfire-components-color-toolbar-picker-style-module__colorPickerPopover--2bh5S";
export const componentsPopover = "components-popover";
export const componentsPopoverContent = "components-popover__content";
export const colorPicker = "smartfire-components-color-toolbar-picker-style-module__colorPicker--J3x5Q";
export const componentsColorPaletteItemWrapper = "components-color-palette__item-wrapper";
export const componentsColorPaletteClear = "components-color-palette__clear";